import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const parsePrice = (s) => {
  if (!s) return null;
  const m = String(s).replace(/,/g, "").match(/(\d+(?:\.\d+)?)\s*(bn|b|billion|m|million|k|thousand)?/i);
  if (!m) return null;
  const mult = { b: 1e9, bn: 1e9, billion: 1e9, m: 1e6, million: 1e6, k: 1e3, thousand: 1e3 }[(m[2] || "").toLowerCase()] || 1;
  return parseFloat(m[1]) * mult;
};

export const EMPTY_FILTERS = { area: "any", min: "", max: "", beds: "any" };

export const applyFilters = (items, f, valueOf = parsePrice) =>
  items.filter((p) => {
    if (f.area !== "any" && (p.international ? p.country || p.location : p.location) !== f.area) return false;
    if (f.beds !== "any" && !((p.bedrooms || 0) >= Number(f.beds))) return false;
    if (f.min || f.max) {
      const v = valueOf(p.price);
      if (v === null) return false;
      if (f.min && v < Number(f.min)) return false;
      if (f.max && v > Number(f.max)) return false;
    }
    return true;
  });

const trigger = "h-[42px] rounded-none bg-transparent border-gw-rule/30 text-gw-ink";
const input = "h-[42px] w-full bg-transparent border border-gw-rule/30 px-3 text-sm text-gw-ink outline-none focus:border-gw-rule placeholder:text-gw-ink/40";

export const RealtyFilters = ({ items, value, onChange, symbol = "₦" }) => {
  const areas = [...new Set(items.map((p) => (p.international ? p.country || p.location : p.location)).filter(Boolean))].sort();
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  const active = JSON.stringify(value) !== JSON.stringify(EMPTY_FILTERS);
  return (
    <div className="grid grid-cols-2 md:grid-cols-[1.4fr_1fr_1fr_1fr_auto] gap-3 items-end mb-10" data-testid="realty-filters">
      <label className="lab text-[11px] col-span-2 md:col-span-1">Area
        <Select value={value.area} onValueChange={set("area")}>
          <SelectTrigger className={`mt-2 ${trigger}`} data-testid="filter-area-select"><SelectValue /></SelectTrigger>
          <SelectContent className="rounded-none">
            <SelectItem value="any">Any area</SelectItem>
            {areas.map((a) => <SelectItem key={a} value={a}>{a}</SelectItem>)}
          </SelectContent>
        </Select>
      </label>
      <label className="lab text-[11px]">Min price ({symbol})
        <input inputMode="numeric" value={value.min} onChange={(e) => set("min")(e.target.value.replace(/[^\d]/g, ""))} placeholder="No min" className={`mt-2 ${input}`} data-testid="filter-min-price" />
      </label>
      <label className="lab text-[11px]">Max price ({symbol})
        <input inputMode="numeric" value={value.max} onChange={(e) => set("max")(e.target.value.replace(/[^\d]/g, ""))} placeholder="No max" className={`mt-2 ${input}`} data-testid="filter-max-price" />
      </label>
      <label className="lab text-[11px]">Bedrooms
        <Select value={value.beds} onValueChange={set("beds")}>
          <SelectTrigger className={`mt-2 ${trigger}`} data-testid="filter-beds-select"><SelectValue /></SelectTrigger>
          <SelectContent className="rounded-none">
            <SelectItem value="any">Any</SelectItem>
            {[1, 2, 3, 4, 5].map((n) => <SelectItem key={n} value={String(n)}>{n}+ beds</SelectItem>)}
          </SelectContent>
        </Select>
      </label>
      <button type="button" disabled={!active} onClick={() => onChange(EMPTY_FILTERS)} data-testid="filter-reset-button"
        className="lab text-[11px] h-[42px] px-4 border border-gw-rule/30 transition-colors duration-200 hover:bg-gw-hover disabled:opacity-40">
        Reset
      </button>
    </div>
  );
};
